<div style="width: 100%;">
  
    <h2 matDialogTitle>Add files to description</h2>
    <mat-dialog-content>
        <app-upload-files #fileUpload></app-upload-files>



    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-flat-button (click)="onCancel()" [disabled]="isLoading">Cancel</button>
      <button mat-raised-button color="primary" (click)="onUpdateDescription()" [disabled]="isLoading">Save</button>
    </mat-dialog-actions>
</div>